import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CancelPersonalEmailSequence as CancelPersonalEmailSequenceMutation,
    CancelPersonalEmailSequenceVariables,
    EmailAutomationStatusCancelInput,
} from 'nutshell-graphql-types';

import CANCEL_PERSONAL_EMAIL_SEQUENCE from '../mutations/cancel-personal-email-sequence.graphql';

export const useCancelPersonalEmailSequence = (): {
    cancelPersonalEmailSequence: (arg1: EmailAutomationStatusCancelInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [cancelPersonalEmailSequence, {loading, error}] = useMutation<
        CancelPersonalEmailSequenceMutation,
        CancelPersonalEmailSequenceVariables
    >(CANCEL_PERSONAL_EMAIL_SEQUENCE);

    return {
        cancelPersonalEmailSequence: (input: EmailAutomationStatusCancelInput) =>
            cancelPersonalEmailSequence({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
